module.exports = __webpack_public_path__ + "img/icon-arrow-2-left.153d69d1.svg";